import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import NavigationMenu from '../components/shared/NavigationMenu';
import Tooltip from '../components/atoms/Tooltip/Tooltip';
import { useSidebar } from '../contexts/SidebarContext';
import { isSelfHost } from '../utils/selfHost';
import './Sidebar.css';

const getInitials = (name) => {
  if (!name) return 'U';
  return name.split(' ').map(word => word[0]).join('').toUpperCase().slice(0, 2);
};

const Sidebar = ({ user, isInsideProject = false }) => {
  const { isExpanded, toggleSidebar } = useSidebar();
  const navigate = useNavigate();
  // Plan-name was a leftover from the subscription era. Credits-first
  // billing has no plan tier — the avatar tile here just links to the
  // billing page. Leaving the slot in case we want to surface the credit
  // balance shorthand here later.
  const [planName] = useState(null);

  return (
    <aside className={`app-sidebar ${isExpanded ? 'expanded' : 'collapsed'}`}>
      <div className="sidebar-content">
        <div className="sidebar-header">
          {isExpanded && isInsideProject && (
            <div className="sidebar-logo" onClick={() => navigate('/')}>
              <img src="/botman-logo.png" alt="Teamy" className="sidebar-logo-img" />
            </div>
          )}
          {/* Inside a project the user-profile lives ONLY in the bottom
              block (sidebar-bottom), anchored to the foot of the sidebar
              below Settings + All Projects — so we don't also show it here.
              The global (non-project) sidebar has no bottom block, so it
              keeps the name/email here as before. */}
          {user && isExpanded && !isInsideProject && (
            <div className="sidebar-user">
              <div className="user-info">
                <h3 className="user-name">{user.name || 'User'}</h3>
                <p className="user-plan">{user.email}</p>
              </div>
            </div>
          )}
          <Tooltip content="⌘+B" position="bottom">
            <button className="sidebar-toggle-btn" onClick={toggleSidebar}>
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                <path d="M0 3a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm5-1v12h9a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1zM4 2H2a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h2z"/>
              </svg>
            </button>
          </Tooltip>
        </div>

        <NavigationMenu collapsed={!isExpanded} />

        {isInsideProject && user && (
          <div
            className={`sidebar-bottom ${isExpanded ? '' : 'sidebar-bottom--collapsed'}`}
            onClick={isSelfHost() ? undefined : () => navigate('/billing')}
            style={{ cursor: isSelfHost() ? 'default' : 'pointer' }}
          >
            <div className={`sidebar-bottom-avatar avatar-${getInitials(user.name || user.email)?.[0]?.toUpperCase() || 'U'}`}>
              {getInitials(user.name || user.email)}
            </div>
            {isExpanded && (
              <div className="sidebar-bottom-info">
                <span className="sidebar-bottom-name">{user.name || 'User'}</span>
                {planName && <span className="sidebar-bottom-plan">{planName} Plan</span>}
              </div>
            )}
          </div>
        )}
      </div>
    </aside>
  );
};

export default Sidebar;
